import React, { useEffect } from 'react';
import './JGLocalOpsMark.css';

const JG_LOGO =
  'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1664565843/Images/JOEGALAXYDopeGalaxyLogooriginal_tecmer.png';

/**
 * Reusable brand lockup: [JG Logo] JG LocalOps
 * Scales with parent font size; no hard pixel sizing.
 */
const JGLocalOpsMark = ({ className = '', actionCreditCount = 0 }) => {
  const hasTrust = Number(actionCreditCount || 0) >= 1;

  useEffect(() => {
    // Dev visibility into trust rendering
    // eslint-disable-next-line no-console
    console.log('[JGLocalOpsMark]', { actionCreditCount, hasTrust });
  }, [actionCreditCount, hasTrust]);

  return (
    <span className={`jg-localops-mark ${className}`.trim()}>
      <img src={JG_LOGO} alt="JG Logo" className="jg-localops-logo" />
      <span className="jg-localops-text">JG LocalOps</span>
      {hasTrust && <span className="jg-localops-trust">Verified Local</span>}
    </span>
  );
};

export default JGLocalOpsMark;
